import { Box, Divider } from '@factorialco/deprecated-design-system'

import { BreakdownWorkedTime } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/BankOfHoursPanel/lib/breakdownWorkedTime'

import ExtraHours from './ExtraHours'
import PaidBreaks from './PaidBreaks'
import RegularHours from './RegularHours'

interface AccordionProps {
  workedTimeBreakdown: BreakdownWorkedTime
}

const Accordion = ({ workedTimeBreakdown }: AccordionProps) => {
  const { breaksMinutes, regularMinues, extraHourMinutes, breaksContributions } =
    workedTimeBreakdown

  return (
    <Box gap="s8" paddingY="s24">
      <Box
        border={{
          all: {
            width: 's1',
            color: 'grey400',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
      >
        {regularMinues > 0 && <RegularHours regularMinues={regularMinues} />}

        {extraHourMinutes > 0 && (
          <>
            <Divider />
            <ExtraHours extraHourMinutes={extraHourMinutes} />
          </>
        )}

        {breaksMinutes > 0 && (
          <>
            <Divider />
            <PaidBreaks breaksMinutes={breaksMinutes} breaksContributions={breaksContributions} />
          </>
        )}
      </Box>
    </Box>
  )
}

export default Accordion
